import { STRATEGY_THEME } from "./strategyCardTheme";

// Builds the 3 Strategy Cards for one Buyer property row (current or an
// expanded previous property). Pulled out of BuyerStrategyPropertyRows.jsx
// into its own pure, Firebase-free module - same reasoning as
// pricingStrategyFormatting.js already being separate - so this decision
// logic is unit-testable without pulling in the Firebase app initialization
// that importing the full component (and its firestoreService import chain)
// would otherwise require real env vars for.
//
// Negotiations/Inspection are always "coming_soon" - no real implementation
// exists behind either yet, for either current or previous properties,
// matching the pre-redesign behavior exactly (those two were never wired to
// real data/handlers).
export function buildBuyerStrategyCards({ hasPricingResult, pricingPreview, pricingLastUpdated, onViewPricing, isCurrent }) {
  return [
    {
      key: "pricing",
      theme: STRATEGY_THEME.pricing,
      description: "Recommended initial offer and price guidance.",
      status: hasPricingResult ? "generated" : isCurrent ? "not_generated" : "restricted",
      restrictedMessage: "No Pricing Strategy generated for this property yet.",
      preview: pricingPreview,
      lastUpdated: pricingLastUpdated,
      onAction: onViewPricing,
    },
    {
      key: "negotiation",
      theme: STRATEGY_THEME.negotiation,
      description: "Negotiating position, options and contract terms.",
      comingSoonDetail: "Get AI guidance on key negotiation points and potential terms.",
      status: "coming_soon",
    },
    {
      key: "inspection",
      theme: STRATEGY_THEME.inspection,
      description: "Property concerns and inspection priorities.",
      status: "coming_soon",
    },
  ];
}

// Known property facts as card chips - only values actually present in
// application state (Strategy inputs, else the transaction's MLS details);
// a missing value is simply left out, never estimated.
function factNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function buildPropertyFacts({ bedrooms, bathrooms, squareFeet, lotSizeSqft }) {
  const beds = factNumber(bedrooms);
  const baths = factNumber(bathrooms);
  const sqft = factNumber(squareFeet);
  const lot = factNumber(lotSizeSqft);
  return [
    beds && { key: "beds", icon: "bed", text: `${beds} Bed` },
    baths && { key: "baths", icon: "bath", text: `${baths} Bath` },
    sqft && { key: "sqft", icon: "expand arrows alternate", text: `${sqft.toLocaleString("en-US")} Sq Ft` },
    lot && { key: "lot", icon: "map outline", text: `${(lot / 43560).toFixed(2)} Ac` },
  ].filter(Boolean);
}
